module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.cssClasses
  }, [_vm._v("\n  " + _vm._s(_vm.name) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92f10d1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/UiIcon.vue
// module id = 281
// module chunks = 2